var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert",class:{
     'alert-error' : _vm.color === 'red' ,
     'alert-success' : _vm.color === 'green'},attrs:{"role":"alert"}},[_vm._v("\n        "+_vm._s(_vm.message)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }